const jwt = require('./jwt');
const aes = require('./aes');
const bcrypt = require('./bcrypt');

module.exports = {
    jwt,
    bcrypt,
    aes,

    //Deprecated:
    encrypt: () => deprecated('bcrypt', 'encrypt'),
    compare: () => deprecated('bcrypt', 'compare'),
    setRandomFallback: () => deprecated('bcrypt', 'setRandomFallback'),
    getRandomFallback: () => deprecated('bcrypt', 'getRandomFallback'),
    getSalt: () => deprecated('bcrypt', 'getSalt'),

    decode: () => deprecated('jwt', 'decode'),
    sign: () => deprecated('jwt', 'sign')
};

function deprecated(algorithm, methodName) {
    throw new Error(
        `DEPRECATED: 'lib_encryption.${methodName}' is deprecated. Please use 'lib_encryption.${algorithm}.${methodName}'`
    );
}
